import React, { useState, useEffect } from 'react';
import Autosuggest from 'react-autosuggest';
import { performLocationSearch } from '../services';
import { Location } from '../models';

interface LocationInputProps {
    defaultValue: Location;
    onSelected: ((location: Location) => void);
}

export const LocationInput = ({ defaultValue, onSelected }: LocationInputProps) => {
    const [value, setValue] = useState('');
    const [suggestions, setSuggestions] = useState<Location[]>([]);

    useEffect(() => {
        setValue(defaultValue.display);
    }, [defaultValue]);

    return <div style={{ position: 'relative' }}><Autosuggest
        suggestions={suggestions}
        shouldRenderSuggestions={(value) => true}
        onSuggestionsClearRequested={() => setSuggestions([])}
        onSuggestionsFetchRequested={async ({ value }) => {
            const locations = await performLocationSearch(value);
            setValue(value);
            setSuggestions(locations);
        }}
        onSuggestionSelected={(event, { suggestion }) => { onSelected(suggestion); }}
        getSuggestionValue={suggestion => suggestion.display}
        renderSuggestion={suggestion => <span>{suggestion.name}</span>}
        inputProps={{
            placeholder: 'Įvesk vietovę',
            value: value,
            onChange: (_, { newValue, method }) => {
                setValue(newValue);
            }
        }}
        highlightFirstSuggestion={true}
    /></div>;
};